export default __webpack_public_path__ + "static/media/red-loose-pin.f9eaa643.svg";